import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
})

export default useStyles
